import type { Aabb } from "./WalkableOffice";

/**
 * Loose outer cage only (~8 m span after autoFit). No furniture blockers —
 * those were trapping the spawn and made WASD feel dead while look still worked.
 */
const H = 3.5;
const T = 0.35;
const X = 3.8;
const Z = 3.8;

export const PHOTOREAL_OFFICE_WALK_COLLIDERS: Aabb[] = [
  { min: [-X - T, 0, -Z], max: [-X, H, Z] },
  { min: [X, 0, -Z], max: [X + T, H, Z] },
  { min: [-X, 0, -Z - T], max: [X, H, -Z] },
  { min: [-X, 0, Z], max: [X, H, Z + T] },
];
